import React, { useState, useContext, useEffect, useMemo, useCallback, useReducer, useRef } from 'react'
import { useTranslation } from "react-i18next";
import { GetAlertsComponent, setObjectByPath, validateConstantValues, translateType } from "./utils"
import AuthContext from '../../../../context/auth-context'
import axios from 'axios'
import { dataFetchReducer } from "../../../Utils/requestUtils"
import { trimNestedObject } from '../../../Utils/utils'
import {
    getRegionFromEnvironment,
    getEnvironmentFromRegion,
    FieldsManager,
    HistoricalDataPicker,
    getEventTypesIntersectionAcrossCompanies,
    RULE_PIECE_CURRENT_COMPANY_KEY,
    areFieldsCleared,
    RULE_PIECE_CURRENT_EVENT_ENUM,
    RULE_PIECE_CURRENT_EVENT_ES_INDEX,
    RULE_PIECE_CURRENT_EVENT_ENVIRONMENT,
    RULE_PIECE_CURRENT_EVENT_REGION,
    RULE_PIECE_CURRENT_EVENT_DATE_PATH,
    filterDatasetEntries,
    isCachedDatasetCompatibleWithMappings,
} from './EventFieldShared'
import Typography from '@mui/material/Typography'
import TextField from "@material-ui/core/TextField";
import MenuItem from '@material-ui/core/MenuItem';
import RulesContext from "../../../../context/rules-context"
import _ from "lodash"
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import TimeDeltaTextField from './Components/TimeDeltaTextField';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import moment from 'moment';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import FormHelperText from '@material-ui/core/FormHelperText';

export function EventFieldCachedAccumulatorBox (props) {
    const { t } = useTranslation();
    let {node} = props
    let {read_only} = props
    let {handleConfigurationOpen} = props
    let {handleNodeRemove} = props
    let rulesList = useContext(RulesContext)

    const helperNode = _.cloneDeep(node)
    nodeToV2Accumulator(helperNode)

    const mappings = helperNode.node.properties.target_event_type?.field_mappings || rulesList.fields_mapper_list || []
    const accumulated_event = mappings.filter(rule => rule.path === helperNode.node.properties.accumulated_field_path)[0]
    let referencedString = "";

    if (helperNode.node.properties.fields && helperNode.node.properties.fields.length > 0) {
        referencedString = helperNode.node.properties.fields.reduce((acc, field, idx, src) => {
            let event = mappings.filter(rule => rule.path === field.target_field_path)[0]
            let description = (event || {description:""}).description
            if (idx === 0) acc = acc + description
            else if (idx === src.length - 1 && src.length > 1) acc = acc + " e " + description
            else acc = acc + ", " + description
            return acc
        }, "")
    }

    function formatTimedelta(timedelta) {
        const duration = moment.duration(timedelta);

        const years = duration.years();
        const months = duration.months();
        const days = duration.days();
        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();

        let formattedString = '';

        if (years > 0) {
            formattedString += `${years} ${t('years')}`;
        }

        if (months > 0) {
            if (formattedString.length > 0) {
                formattedString += ', '
            }
            formattedString += `${months} ${t('months')}`;
        }

        if (days > 0) {
            if (formattedString.length > 0) {
                formattedString += ', '
            }
            formattedString += `${days} ${t('days')}`;
        }

        if (hours > 0) {
            if (formattedString.length > 0) {
                formattedString += ', '
            }
            formattedString += `${hours} ${t('hours')}`;
        }

        if (minutes > 0) {
            if (formattedString.length > 0) {
                formattedString += ', '
            }
            formattedString += `${minutes} ${t('minutes')}`;
        }

        if (seconds > 0) {
            if (formattedString.length > 0) {
                formattedString += ', '
            }
            formattedString += `${seconds} ${t('seconds')}`;
        }

        return formattedString.trim();
    }

    return (
        <div>
            {!read_only ?
                <div style={{display:"flex", alignItems: "center"}}>
                    <div
                        style={{display:"flex", width:"100%", cursor:"pointer", margin: "0px"}}
                        onClick={() => handleConfigurationOpen(helperNode)}
                    >
                        <div style={{display: "flex",flexDirection: "column",margin: "auto 0px"}}>
                            <div className={["normalText","normalMediumSize"].join(" ")}>
                            {t("Acumular")} {t((accumulated_event || {description:""}).description)} {t("para o mesmo")} {t(referencedString)}
                            </div>
                            <div className={["normalText","normalSmallSize"].join(" ")}>
                            {helperNode.node.properties.timedelta_value
                            ?
                            t(" nos últimos ") + formatTimedelta(helperNode.node.properties.timedelta_value)
                            :
                            t(" em todo o histórico")}
                            </div>
                        </div>
                        {(helperNode.node.alerts || []).length > 0?
                        <GetAlertsComponent alerts={helperNode.node.alerts} />  : null}
                    </div>
                    <IconButton style={{width: 32, height: 32}} aria-label="duplicate" onClick={() => props.handleNodeDuplication(helperNode)}>
                        <ContentCopyIcon style={{width: 20, height: 20}} />
                    </IconButton>
                    <IconButton style={{width: 32, height: 32}} aria-label="close" onClick={() => handleNodeRemove(helperNode)}>
                        <CloseIcon style={{width: 20, height: 20}} />
                    </IconButton>
                </div>
                :
                <div style={{display:"flex"}}>
                    <div
                        style={{display:"flex", width:"100%", cursor:"pointer", margin: "0px"}}
                        onClick={() => handleConfigurationOpen(helperNode)}
                    >
                        <div style={{display: "flex",flexDirection: "column",margin: "auto 0px"}}>
                            <div className={["normalText","normalMediumSize"].join(" ")}>
                            {t("Acumular")} {t((accumulated_event || {description:""}).description)} {t("para o mesmo")} {t(referencedString)}
                            </div>
                            <div className={["normalText","normalSmallSize"].join(" ")}>
                            {helperNode.node.properties.timedelta_value
                            ?
                            t(" nos últimos ") + formatTimedelta(helperNode.node.properties.timedelta_value)
                            :
                            t(" em todo o histórico")}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export function EventFieldCachedAccumulatorConfiguration(props){
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 280,
            },
        },
    };

    const CLAMP_HINT_FLASH_MS = 900

    const { t } = useTranslation();
    let {node} = props
    let {read_only} = props
    let {handleNodeChange} = props
    let {handleConfigurationClose} = props
    let {userVariables} = props
    let rulesList = useContext(RulesContext)
    let authContext = useContext(AuthContext)
    const { isRulePiece } = rulesList
    const box_settings = rulesList.boxes[node.node.type]?.settings || {}
    let rule_company_key = (rulesList?.company_key && rulesList?.company_key !== "") ? rulesList?.company_key : authContext.user_data?.company_key
    const company = rulesList.company
    const companyList = useMemo(() => (Array.isArray(company) ? company : [company]), [company])

    const rule_event_type = useMemo(() => {
        let ruleEventType = rulesList?.event_type
        if (isRulePiece) {
            let validCompanyEvent = null
            if (isNodeV1Accumulator(node)) {
                const fieldPaths = [
                    ...(node.node.properties.referenced_field_paths || []),
                    ...(node.node.properties.static_fields || []).map(f => f.field_path)
                ].filter(Boolean)
                for (let comp of companyList) {
                    const companyEventCandidate = comp.company_events?.find(event =>
                        fieldPaths.every(path =>
                            event.field_mapping?.field_mappings?.some(mapping => mapping.path === path)
                        )
                    )
                    if (companyEventCandidate) {
                        validCompanyEvent = companyEventCandidate
                        break
                    }
                }
            } else {
                validCompanyEvent = companyList?.[0]?.company_events?.[0]
            }
            ruleEventType = validCompanyEvent?.field_mapping?.event_type
            ruleEventType = {
                ...ruleEventType,
                enum: RULE_PIECE_CURRENT_EVENT_ENUM,
                es_index: RULE_PIECE_CURRENT_EVENT_ES_INDEX,
                rule_company_key: RULE_PIECE_CURRENT_COMPANY_KEY,
                event_date_path: RULE_PIECE_CURRENT_EVENT_DATE_PATH
            }
        } else {
            const ruleCompany = companyList.find(comp => comp.company_key === rule_company_key)
            const ruleRegion = getRegionFromEnvironment(rulesList.environment)
            ruleEventType = ruleCompany?.company_events?.find(event =>
                event.field_mapping?.event_type?.enum === rulesList?.event_type &&
                getRegionFromEnvironment(event.field_mapping?.event_type?.environment) === ruleRegion
            )?.field_mapping?.event_type
        }
        return ruleEventType
    }, [rulesList.event_type, companyList, rule_company_key, rulesList.environment, isRulePiece, node])

    if (rule_event_type?.rule_company_key) {
        rule_company_key = rule_event_type.rule_company_key
    }

    let settingsFilters = (box_settings.filters || [])

    const [nodeState, setNodeState] = useState(() => {
        let new_node = _.cloneDeep(node)
        nodeToV2Accumulator(new_node)
        const target_event_type = new_node.node.properties?.target_event_type ?? rule_event_type
        if (target_event_type && !target_event_type.environment && target_event_type.region) {
            target_event_type.environment = getEnvironmentFromRegion(target_event_type.region, rulesList.environment)
        }
        if (new_node.node.properties?.search_with_business_group_key) {
            new_node.node.properties.target_company_key = "every_company"
        } else {
            new_node.node.properties.target_company_key = new_node.node.properties?.target_company_key ?? rule_company_key
        }
        new_node.node.properties.target_event_type = target_event_type
        return new_node
    })
    const enableBusinessGroupQueryOption = (box_settings?.enable_business_group_query_option ?? false)
    const useAdvancedMode = (box_settings?.use_advanced_mode ?? false)
    const [openChangeWarning, setOpenChangeWarning] = useState(false)
    const [pendingValue, setPendingValue] = useState(null)
    const [open, setOpen] = useState(true)
    const [clampHintFlash, setClampHintFlash] = useState(false)
    const clampHintFlashTimeoutRef = useRef(null)
    const [targetFieldMapping, dispatchTargetFieldMapping] = useReducer(dataFetchReducer, {
        fetchedData: null,
        isLoading: true,
        isError: false,
    })

    useEffect(() => {
        return () => {
            if (clampHintFlashTimeoutRef.current != null) {
                clearTimeout(clampHintFlashTimeoutRef.current)
            }
        }
    }, [])

    const getFilteredCompany = useCallback((targetCompanyKey) => {
        const effectiveKey = targetCompanyKey || rule_company_key
        if (effectiveKey === RULE_PIECE_CURRENT_COMPANY_KEY) {
            return null
        }
        return companyList.filter((comp) =>
            effectiveKey === "every_company" || effectiveKey === comp.company_key
        )
    }, [rule_company_key, companyList])

    const getEventsForCompany = useCallback((targetCompanyKey) => {
        if (targetCompanyKey === RULE_PIECE_CURRENT_COMPANY_KEY) {
            return getEventTypesIntersectionAcrossCompanies(companyList)
        }
        const filteredCompany = getFilteredCompany(targetCompanyKey)
        if (filteredCompany == null) {
            return []
        }
        const seenEvents = new Set()
        return filteredCompany.flatMap((comp) =>
            (comp.company_events || [])
                .map(event => event.field_mapping?.event_type)
                .filter(Boolean)
                .filter(eventType => {
                    const key = `${eventType.enum}$#$${getRegionFromEnvironment(eventType.environment)}`
                    if (seenEvents.has(key)) return false
                    seenEvents.add(key)
                    return true
                })
        )
    }, [getFilteredCompany, companyList])

    const concreteCompanyEvents = useMemo(
        () => getEventsForCompany(nodeState?.node?.properties?.target_company_key) || [],
        [getEventsForCompany, nodeState.node.properties.target_company_key]
    )

    const showRulePieceNoSharedEventTypesHint =
        isRulePiece &&
        nodeState?.node?.properties?.target_company_key ===
            RULE_PIECE_CURRENT_COMPANY_KEY &&
        concreteCompanyEvents.length === 0

    const getFieldMappingObjectFromEventType = useCallback((targetCompanyKey, targetEventEnum, targetEventEnvironment) => {
        if (!targetEventEnum) return null

        const filteredCompany = targetCompanyKey === RULE_PIECE_CURRENT_COMPANY_KEY
            ? (companyList || []).filter(Boolean)
            : getFilteredCompany(targetCompanyKey)

        if (filteredCompany == null) {
            return null
        }
        const matchingEvent = filteredCompany
            .flatMap(comp => comp.company_events || [])
            .find(event =>
                event.field_mapping?.event_type?.enum === targetEventEnum &&
                getRegionFromEnvironment(event.field_mapping?.event_type?.environment) === getRegionFromEnvironment(targetEventEnvironment)
            )
        return matchingEvent?.field_mapping ?? null
    }, [getFilteredCompany])

    const currentTargetEvent = nodeState?.node?.properties?.target_event_type ?? rule_event_type
    const currentTargetEventEnum = currentTargetEvent?.enum
    const currentTargetEventEnvironment = currentTargetEvent?.environment
    const currentTargetCompanyKey = nodeState?.node?.properties?.target_company_key
    const selectedRegion =
        currentTargetEvent?.region ??
        getRegionFromEnvironment(currentTargetEvent?.environment ?? '')
    const selectedEnum = currentTargetEvent?.enum
    const fieldsMapperList = useMemo(() => rulesList.fields_mapper_list || [], [rulesList])

    useEffect(() => {
        if (!currentTargetEventEnum) return
        if (currentTargetEventEnum === RULE_PIECE_CURRENT_EVENT_ENUM) {
            dispatchTargetFieldMapping({ type: "data_fetch_success", payload: { mappings: fieldsMapperList } })
            return
        }
        const targetFieldMappingObject = getFieldMappingObjectFromEventType(currentTargetCompanyKey, currentTargetEventEnum, currentTargetEventEnvironment)
        const targetFieldMappingKey = targetFieldMappingObject?.field_mapping_key
        const targetFieldMappingEnvironment = targetFieldMappingObject?.event_type?.environment
        dispatchTargetFieldMapping({ type: "data_fetch_init" })
        const timer = setTimeout(() => {
            axios
                .get(`/dash/rule_engine/event_type/${currentTargetEventEnum}/field_mapping/${targetFieldMappingKey}?environment=${targetFieldMappingEnvironment}`)
                .then((response) => {
                    dispatchTargetFieldMapping({ type: "data_fetch_success", payload: response.data })
                })
                .catch((error) => {
                    if ((error.response || {}).status === 403) dispatchTargetFieldMapping({ type: "data_fetch_failure_403" })
                    else if ((error.response || {}).status === 404) dispatchTargetFieldMapping({ type: "data_fetch_failure_404" })
                    else dispatchTargetFieldMapping({ type: "data_fetch_failure" })
                })
        }, 500)
        return () => clearTimeout(timer)
    }, [currentTargetEventEnum, currentTargetEventEnvironment, currentTargetCompanyKey, fieldsMapperList, getFieldMappingObjectFromEventType])

    const datasetsForFilter = box_settings?.datasets
    const fetchedMappings = targetFieldMapping?.fetchedData?.mappings
    const fieldMappingIsLoading = targetFieldMapping?.isLoading
    const isFieldMappingAvailable = !!fetchedMappings && !fieldMappingIsLoading

    const compatibleDatasetEntries = useMemo(() => {
        if (!datasetsForFilter || !isFieldMappingAvailable) {
            return []
        }
        return filterDatasetEntries(
            datasetsForFilter,
            fetchedMappings,
            selectedRegion,
            selectedEnum,
        )
    }, [
        datasetsForFilter,
        isFieldMappingAvailable,
        fetchedMappings,
        selectedRegion,
        selectedEnum,
    ])

    useEffect(() => {
        if (read_only || !datasetsForFilter || !isFieldMappingAvailable) {
            return
        }
        if (compatibleDatasetEntries.length !== 1) {
            return
        }
        const onlyKey = compatibleDatasetEntries[0].key
        setNodeState((prev) => {
            if (prev.node.properties.dataset === onlyKey) {
                return prev
            }
            const new_node = _.cloneDeep(prev)
            setObjectByPath(new_node.node, "properties.dataset", onlyKey)
            return new_node
        })
    }, [
        compatibleDatasetEntries,
        read_only,
        isFieldMappingAvailable,
        datasetsForFilter,
    ])

    const clearEventTypeInfo = (new_node) => {
        const field = new_node.node.properties.fields?.[0] || { type: "dynamic" }
        new_node.node.properties.fields = [{ ...field, target_field_path: null, comparison: null, value: null }]
        setObjectByPath(new_node.node, "properties.dataset", "")
    }

    const changeTargetCompanyKey = (newValue, new_node) => {
        if (newValue === "every_company") {
            setObjectByPath(new_node.node, "properties.search_with_business_group_key", true)
        } else {
            setObjectByPath(new_node.node, "properties.search_with_business_group_key", false)
        }
        const nextEvents = getEventsForCompany(newValue)
        const currentTargetEventLocal = nodeState?.node?.properties?.target_event_type
        if (nextEvents.length === 1) {
            setObjectByPath(new_node.node, "properties.target_event_type", nextEvents[0])
        } else {
            setObjectByPath(new_node.node, "properties.target_event_type",
                nextEvents.find(event =>
                    event.enum === currentTargetEventLocal?.enum &&
                    getRegionFromEnvironment(event.environment) === getRegionFromEnvironment(currentTargetEventLocal?.environment)
                ) || null
            )
        }
        setObjectByPath(new_node.node, "properties.target_company_key", newValue)
        setNodeState(new_node)
    }

    const handleTargetCompanyKeyChange = (e, newValue) => {
        if (areFieldsCleared(nodeState?.node?.properties?.fields)) {
            const new_node = _.cloneDeep(nodeState)
            changeTargetCompanyKey(newValue, new_node)
            return
        }
        setPendingValue({ type: "target_company_key", value: newValue })
        setOpenChangeWarning(true)
    }

    const changeTargetEventType = (newValue, new_node) => {
        setObjectByPath(new_node.node, "properties.target_event_type", newValue)
        setNodeState(new_node)
    }

    const handleTargetEventTypeChange = (e, newValue) => {
        if (areFieldsCleared(nodeState?.node?.properties?.fields)) {
            const new_node = _.cloneDeep(nodeState)
            changeTargetEventType(newValue, new_node)
            return
        }
        setPendingValue({ type: "target_event_type", value: newValue })
        setOpenChangeWarning(true)
    }

    const handleUpdateFields = (updatedFields) => {
        const new_node = _.cloneDeep(nodeState)
        setObjectByPath(new_node.node.properties, "fields", updatedFields)
        setNodeState(new_node)
    }

    const formatMaxTimedeltaForHint = (iso) => {
        const duration = moment.duration(iso)
        const parts = []
        const years = duration.years()
        const months = duration.months()
        const days = duration.days()
        const hours = duration.hours()
        const minutes = duration.minutes()
        const seconds = duration.seconds()
        const millis = duration.milliseconds()

        if (years > 0) {
            parts.push(`${years} ${t('years')}`)
        }
        if (months > 0) {
            parts.push(`${months} ${t('months')}`)
        }
        if (days > 0) {
            parts.push(`${days} ${t('days')}`)
        }
        if (hours > 0) {
            parts.push(`${hours} ${t('hours')}`)
        }
        if (minutes > 0) {
            parts.push(`${minutes} ${t('minutes')}`)
        }
        if (seconds > 0) {
            parts.push(`${seconds} ${t('seconds')}`)
        }
        if (millis > 0) {
            parts.push(`${millis} ${t('milliseconds')}`)
        }

        if (parts.length === 0) {
            return `0 ${t('seconds')}`
        }
        return parts.join(', ')
    }

    const validateAllValues = () => {
        if (box_settings?.datasets) {
            if ((nodeState.node.properties.dataset || "").length === 0) {
                return false
            }
            if (
                !targetFieldMapping?.fetchedData?.mappings ||
                targetFieldMapping.isLoading
            ) {
                return false
            }
            if (
                !isCachedDatasetCompatibleWithMappings(
                    nodeState.node.properties.dataset,
                    box_settings.datasets,
                    targetFieldMapping.fetchedData.mappings,
                    selectedRegion,
                    selectedEnum,
                )
            ) {
                return false
            }
        }
        if (!nodeState.node.properties.target_company_key) return false
        if (!nodeState.node.properties.target_event_type) return false
        if (!nodeState.node.properties.accumulated_field_path || nodeState.node.properties.accumulated_field_path.length === 0) return false
        const fields = nodeState.node.properties.fields || []
        if (fields.length === 0) return false
        const seenFields = new Set()
        for (const field of fields) {
            const sig = `${field.target_field_path},${field.comparison},${field.value},${field.type}`
            if (seenFields.has(sig)) return false
            seenFields.add(sig)
        }
        const mappings = targetFieldMapping?.fetchedData?.mappings || nodeState.node.properties.target_event_type?.field_mappings || []
        const hasInvalidFields = fields.some(field => {
            const targetType = mappings.find(item => item.path === field.target_field_path)?.type
            return !field?.target_field_path || field?.target_field_path.length === 0 ||
                field?.comparison == null || field?.comparison === "" ||
                (field.value === undefined && field.value !== "") ||
                (field.type === "static" && targetType && !validateConstantValues(targetType, field.value))
        })
        if (hasInvalidFields) return false
        if (nodeState.node.properties.timedelta_value) {
            if (!validateConstantValues("timedelta", nodeState.node.properties.timedelta_value)) return false
            if (box_settings?.timedelta_value) {
                const settingsDuration = moment.duration(box_settings.timedelta_value)
                const propertiesDuration = moment.duration(nodeState.node.properties.timedelta_value)
                if (propertiesDuration.asMilliseconds() > settingsDuration.asMilliseconds()) {
                    return false
                }
            }
        }
        return true
    }

    const handleEventChange = (e) => {
        let new_node = _.cloneDeep(nodeState)
        setObjectByPath(new_node.node,"properties.accumulated_field_path",e.target.value)
        setNodeState(new_node)
    }

    const handleValueChange = (path, val) => {
        let new_node = _.cloneDeep(nodeState)
        if (val === "P") val = null
        setObjectByPath(new_node.node,path,val)
        setNodeState(new_node)
    }

    const handleTimedeltaValueChange = (value) => {
        const maxIso = box_settings?.timedelta_value
        if (!maxIso) {
            handleValueChange('properties.timedelta_value', value)
            return
        }
        if (value == null || value === '') {
            handleValueChange('properties.timedelta_value', value)
            return
        }
        if (!validateConstantValues('timedelta', value)) {
            handleValueChange('properties.timedelta_value', value)
            return
        }
        const valueMs = moment.duration(value).asMilliseconds()
        const maxMs = moment.duration(maxIso).asMilliseconds()
        if (valueMs > maxMs) {
            if (clampHintFlashTimeoutRef.current != null) {
                clearTimeout(clampHintFlashTimeoutRef.current)
            }
            setClampHintFlash(true)
            clampHintFlashTimeoutRef.current = setTimeout(() => {
                setClampHintFlash(false)
                clampHintFlashTimeoutRef.current = null
            }, CLAMP_HINT_FLASH_MS)
            handleValueChange('properties.timedelta_value', maxIso)
        } else {
            handleValueChange('properties.timedelta_value', value)
        }
    }

    const handleDatasetChange = (e) => {
        if (e.target.value === "loading") {
            return
        }
        let new_node = _.cloneDeep(nodeState)
        setObjectByPath(new_node.node, "properties.dataset", e.target.value)
        setNodeState(new_node)
    }

    const handleFilterChange = (event, path) => {
        let new_node = _.cloneDeep(nodeState)

        const { value } = event.target

        if(!new_node.node.properties.filters){
            new_node.node.properties.filters = {}
        }

        if(!new_node.node.properties.filters[path]){
            new_node.node.properties.filters[path] =[]
        }

        new_node.node.properties.filters[path] = value;

        if(new_node.node.properties.filters[path].length === 0){
            delete new_node.node.properties.filters[path]
        }

        if(_.size(new_node.node.properties.filters)=== 0) {
            delete new_node.node.properties.filters
        }

        setNodeState(new_node)
    };

    let options_dictionary = {}
    for(let filter of settingsFilters){
        options_dictionary[filter.path] = {};
        for(let option of filter.options){
            options_dictionary[filter.path][option.enum] = option.description
        }
    }

    let filter_rendered_values = {}
    for(let filter of settingsFilters){
        let translated_values = []
        for(let selected_option of ((nodeState.node.properties.filters||{})[filter.path]||[])){
            translated_values.push(options_dictionary[filter.path][selected_option])
        }
        filter_rendered_values[filter.path] = translated_values.join(', ')
    }

    const configurePayload = () => {
        const payload = _.cloneDeep(nodeState)
        const usedFieldPaths = new Set()
        let properties = payload.node.properties

        const fields = properties.fields || []
        fields.forEach(field => {
            if (field?.target_field_path) usedFieldPaths.add(field.target_field_path)
        })
        if (properties.accumulated_field_path) usedFieldPaths.add(properties.accumulated_field_path)

        const selectedDatasetKey = properties.dataset
        if (selectedDatasetKey && box_settings?.datasets?.[selectedDatasetKey]) {
            for (const path of box_settings.datasets[selectedDatasetKey]
                .additional_field_paths || []) {
                if (path) {
                    usedFieldPaths.add(path)
                }
            }
        }

        const sourceMappings =
            targetFieldMapping?.fetchedData?.mappings ||
            properties.target_event_type?.field_mappings ||
            []

        if (properties.target_event_type && sourceMappings.length > 0) {
            properties.target_event_type.field_mappings = sourceMappings.filter(m => usedFieldPaths.has(m.path))
        }

        if (properties.target_event_type) {
            const tet = properties.target_event_type
            if (
                tet?.environment === RULE_PIECE_CURRENT_EVENT_ENVIRONMENT ||
                tet?.enum === RULE_PIECE_CURRENT_EVENT_ENUM
            ) {
                tet.region = RULE_PIECE_CURRENT_EVENT_REGION
            } else if (tet?.environment != null) {
                tet.region = getRegionFromEnvironment(tet.environment)
            }
            if (tet?.environment != null) {
                delete tet.environment
            }
            delete properties.target_event_type?.description
            delete properties.target_event_type?.rule_company_key
        }
        if (properties.search_with_business_group_key) {
            delete properties.target_company_key
        }
        properties = trimNestedObject(properties)
        if (Array.isArray(properties.fields)) {
            properties.fields = properties.fields.map(f => trimNestedObject(f))
        }
        payload.node.properties = properties

        return payload
    }

    const handleSave = () => {
        handleConfigurationClose()
        handleNodeChange(configurePayload())
    }

    const handleClose = () => {
        handleConfigurationClose()
        setOpen(false)
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        minWidth: "300px",
                        maxWidth: "500px"
                    }
                }
            }}
        >
        <div style={{flexGrow:"1", padding: "20px", display:"flex", flexDirection:"column", width: "100%", overflow: "auto", overflowX: "hidden"}}>
            <div style={{display: "flex", justifyContent: "space-between"}}>
                <span className={["blueText", "titleSize"].join(" ")}>{t(node.node.description)}</span>
                <Tooltip title={<div className="tooltipText"><ul>{node.node.helperText.map((help,index) => (<li key={index}>{t(help)}</li>))}</ul></div>}>
                    <HelpIcon style={{fontSize: "16px", display:"flex", margin:"auto 5px"}}/>
                </Tooltip>
            </div>

            {nodeState && useAdvancedMode && (
                <div style={{ marginBottom: "24px" }}>
                    <HistoricalDataPicker
                        targetCompanyKey={nodeState.node.properties?.target_company_key}
                        targetEventType={nodeState.node.properties?.target_event_type}
                        companyList={companyList}
                        companyEvents={concreteCompanyEvents}
                        ruleEventType={rule_event_type}
                        isRulePiece={isRulePiece}
                        readOnly={read_only}
                        enableBusinessGroupQueryOption={enableBusinessGroupQueryOption}
                        onCompanyKeyChange={handleTargetCompanyKeyChange}
                        onEventTypeChange={handleTargetEventTypeChange}
                        showRulePieceNoSharedEventTypesHint={showRulePieceNoSharedEventTypesHint}
                    />
                </div>
            )}

            {box_settings?.datasets ?
                <div style={{display: "flex", flexDirection: "column", gap: 8, margin: "12px 0 12px 0", width: "100%"}}>
                    <p className={["blueText", "subtitleSize", "labelSpace"].join(" ")} style={{width: "100%", marginLeft: 0}}>{t('dataset')}</p>
                    <TextField
                        label={t('dataset')}
                        error={
                            (isFieldMappingAvailable &&
                                !(nodeState.node.properties.dataset || "").length) ||
                            (isFieldMappingAvailable &&
                                Boolean(nodeState.node.properties.dataset) &&
                                !isCachedDatasetCompatibleWithMappings(
                                    nodeState.node.properties.dataset,
                                    box_settings.datasets,
                                    targetFieldMapping.fetchedData.mappings,
                                    selectedRegion,
                                    selectedEnum,
                                ))
                        }
                        className="filterTextbox"
                        size="small" fullWidth
                        value={
                            !isFieldMappingAvailable
                                ? "loading"
                                : (nodeState.node.properties.dataset || "")
                        }
                        onChange={(e) => handleDatasetChange(e)}
                        select
                        disabled={read_only || !isFieldMappingAvailable}
                        InputProps={{
                            readOnly: read_only
                        }}
                    >
                        {!isFieldMappingAvailable ? (
                            <MenuItem value="loading">
                                <em className="normalText">{t("Carregando...")}</em>
                            </MenuItem>
                        ) : (
                            compatibleDatasetEntries.map((dataset) => (
                                <MenuItem key={dataset.key} value={dataset.key}>
                                    {dataset.description}
                                </MenuItem>
                            ))
                        )}
                    </TextField>
                    {isFieldMappingAvailable &&
                    Object.keys(box_settings.datasets).length > 0 &&
                    compatibleDatasetEntries.length === 0 ? (
                        <FormHelperText>{t("cached_dataset_no_compatible_mappings")}</FormHelperText>
                    ) : null}
                </div>
            : null}

            <div className="internalCardContainer" style={{display:"flex", flexDirection: "column", margin: "12px 0", width:"100%"}}>
                {nodeState && (
                    <>
                        <p className={["blueText", "subtitleSize"].join(" ")} style={{width: "100%", margin: "0"}}>
                            {t("Campo a ser acumulado")}
                        </p>
                        <TextField
                            label={t("Campo Acumulado")}
                            style={{textAlign:"center", width: "100%", margin: "12px 0 16px 0"}}
                            error={!nodeState.node.properties.accumulated_field_path}
                            className="filterTextbox"
                            size="small"
                            fullWidth
                            value={nodeState.node.properties.accumulated_field_path || ""}
                            onChange={handleEventChange}
                            select
                            InputProps={{ readOnly: read_only }}
                        >
                            {(() => {
                                const mappings = targetFieldMapping?.fetchedData?.mappings || nodeState.node.properties.target_event_type?.field_mappings || rulesList.fields_mapper_list || []
                                return mappings.filter(f => f.type === "number").map((field, index) => (
                                    <MenuItem key={index} value={field.path}><em className="normalText">{t(field.description) + " (" + t(translateType(field.type)) + ")"}</em></MenuItem>
                                ))
                            })()}
                        </TextField>
                    </>
                )}
                <FieldsManager
                    read_only={read_only}
                    fields={nodeState.node.properties.fields || []}
                    onUpdate={handleUpdateFields}
                    rulesList={rulesList}
                    fieldMapping={targetFieldMapping}
                    userVariables={userVariables}
                    useAdvancedMode={useAdvancedMode}
                    sectionTitle={t("Referências")}
                />
                <p className={["blueText", "subtitleSize"].join(" ")} style={{width: "100%", margin: "0", marginTop: "12px"}}>{t("Configurações")}</p>
                {settingsFilters.map(filter =>
                    <FormControl key={filter.path} style={{textAlign:"center", width:"100%", margin:"0 auto 12px auto"}}>
                        <InputLabel id="demo-multiple-checkbox-label">{t(filter.description)}</InputLabel>
                        <br></br>
                        <Select
                            labelId="demo-multiple-checkbox-label"
                            id="demo-multiple-checkbox"
                            multiple
                            value={((nodeState.node.properties.filters||{})[filter.path]||[])}
                            onChange={(event) => handleFilterChange(event, filter.path)}
                            input={<Input />}
                            renderValue={(selected) => (filter_rendered_values[filter.path])}
                            MenuProps={MenuProps}
                            InputProps={{ readOnly: read_only }}
                        >
                            {[...(filter.options || [])].sort((a, b) => (a.description || "").localeCompare(b.description || "")).map((option) => (
                                <MenuItem key={option.enum} value={option.enum} name={option.description}>
                                    <Checkbox color="primary" checked={((nodeState.node.properties.filters||{})[filter.path]||[]).includes(option.enum)} />
                                    <ListItemText primary={t(option.description)} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
                <TimeDeltaTextField
                    value={nodeState.node.properties.timedelta_value ? nodeState.node.properties.timedelta_value : ""}
                    error={nodeState.node.properties.timedelta_value ? !validateConstantValues("timedelta",nodeState.node.properties.timedelta_value) : false}
                    valueChangeFunction={handleTimedeltaValueChange}
                    label={t("Período de Tempo considerado")}
                    read_only={read_only}
                />
            </div>
            {box_settings?.timedelta_value ? (
                <p
                    className={['normalText', 'normalSmallSize'].join(' ')}
                    style={{
                        margin: '0 auto 12px auto',
                        maxWidth: '80%',
                        textAlign: 'center',
                        fontWeight: clampHintFlash ? 'bold' : undefined,
                        color: clampHintFlash ? '#d32f2f' : undefined,
                        opacity: clampHintFlash ? 1 : 0.85,
                        transition: 'color 0.35s ease, opacity 0.35s ease',
                    }}
                >
                    {t('cached_counter_max_timedelta_hint', {
                        duration: formatMaxTimedeltaForHint(
                            box_settings.timedelta_value,
                        ),
                    })}
                </p>
            ) : null}
            <div style={{display:"flex"}}>
                <div
                    className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                    style={{width:"50%"}}
                    onClick={handleClose}
                >
                    {read_only ? "X" : t("discard")}
                </div>
                {!read_only &&
                <div
                    className={
                        validateAllValues()
                        ?
                        ["button", "standard", "normalText", "normalMediumSize"].join(" ")
                        :
                        ["button", "standard", "normalText", "normalMediumSize","disabled"].join(" ")}
                    style={{width:"50%"}}
                    onClick={validateAllValues() ? handleSave : null}
                >
                    {t("save")}
                </div>}
            </div>
        </div>
            {openChangeWarning && pendingValue && (
                <Dialog
                    open={openChangeWarning}
                    onClose={() => {
                        setOpenChangeWarning(false)
                        setPendingValue(null)
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{
                        "& .MuiDialog-container": {
                            "& .MuiPaper-root": {
                                width: "100%",
                                minWidth: "250px",
                                maxWidth: "350px"
                            }
                        }
                    }}
                >
                    <DialogTitle id="alert-dialog-title">
                        {t("Alterar o tipo de evento limpará os campos configurados")}
                    </DialogTitle>
                    <DialogContent>
                        <Typography id="alert-dialog-description">
                            {t("Deseja continuar?")}
                        </Typography>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", padding: "16px 24px", width: "100%" }}>
                        <div
                            className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                            style={{ width: "50%" }}
                            onClick={() => {
                                setOpenChangeWarning(false)
                                setPendingValue(null)
                            }}
                        >
                            {t("Não")}
                        </div>
                        <div
                            className={["button", "standard", "normalText", "normalMediumSize"].join(" ")}
                            style={{ width: "50%" }}
                            onClick={() => {
                                const new_node = _.cloneDeep(nodeState)
                                clearEventTypeInfo(new_node)
                                if (pendingValue.type === "target_company_key") {
                                    changeTargetCompanyKey(pendingValue.value, new_node)
                                } else if (pendingValue.type === "target_event_type") {
                                    changeTargetEventType(pendingValue.value, new_node)
                                }
                                setOpenChangeWarning(false)
                                setPendingValue(null)
                            }}
                        >
                            {t("Sim")}
                        </div>
                    </DialogActions>
                </Dialog>
            )}
        </Dialog>
    )
}

function isNodeV1Accumulator(node) {
    const properties = node?.node?.properties
    return (
        !Array.isArray(properties?.fields) &&
        (Array.isArray(properties?.referenced_field_paths) || Array.isArray(properties?.static_fields))
    )
}

function translateReferencesV1toV2(referenced_field_paths, static_fields) {
    const newFields = []
    if (Array.isArray(referenced_field_paths)) {
        referenced_field_paths.forEach((path) => {
            if (typeof path === "string" && path.trim() !== "") {
                newFields.push({
                    target_field_path: path,
                    value: path,
                    comparison: "equal",
                    type: "dynamic"
                })
            }
        })
    }
    if (Array.isArray(static_fields)) {
        static_fields.forEach((field) => {
            const type = field?.user_variable_name != null ? "user_variable" : "static"
            if (field && field.field_path) {
                newFields.push({
                    target_field_path: field.field_path,
                    comparison: field.comparison || "equal",
                    value: type === "user_variable" ? field.user_variable_name : field.value,
                    type: type
                })
            }
        })
    }
    return newFields
}

function nodeToV2Accumulator(node) {
    const properties = node?.node?.properties
    if (!isNodeV1Accumulator(node)) return node
    node.node.properties.fields = translateReferencesV1toV2(
        properties?.referenced_field_paths,
        properties?.static_fields
    )
    delete node.node.properties.referenced_field_paths
    delete node.node.properties.static_fields
    delete node.node.properties.match_number
    return node
}

export class EventFieldCachedAccumulatorBoxClass {
    constructor(rulesContext){
        this.rulesContext = rulesContext
        this.formatTimedelta = (timedelta) => {
            const duration = moment.duration(timedelta);

            const years = duration.years();
            const months = duration.months();
            const days = duration.days();
            const hours = duration.hours();
            const minutes = duration.minutes();
            const seconds = duration.seconds();

            let formattedString = '';

            if (years > 0) {
                formattedString += `${years} anos`;
            }

            if (months > 0) {
                if (formattedString.length > 0) {
                    formattedString += ', '
                }
                formattedString += `${months} meses`;
            }

            if (days > 0) {
                if (formattedString.length > 0) {
                    formattedString += ', '
                }
                formattedString += `${days} dias`;
            }

            if (hours > 0) {
                if (formattedString.length > 0) {
                    formattedString += ', '
                }
                formattedString += `${hours} horas`;
            }

            if (minutes > 0) {
                if (formattedString.length > 0) {
                    formattedString += ', '
                }
                formattedString += `${minutes} minutos`;
            }

            if (seconds > 0) {
                if (formattedString.length > 0) {
                    formattedString += ', '
                }
                formattedString += `${seconds} segundos`;
            }

            return formattedString.trim();
        }
    }
    validate(node){
        let put_error = false
        let alerts = []
        const isV1 = isNodeV1Accumulator(node)
        const validateNode = _.cloneDeep(node)
        nodeToV2Accumulator(validateNode)
        const props = validateNode.node.properties
        const mappings =
            props.target_event_type?.field_mappings ||
            this.rulesContext?.fields_mapper_list ||
            []

        const cachedSettings = this.rulesContext?.boxes?.event_field_cached_accumulator_box?.settings

        if ((validateNode.node.children || []).length !== 0) {
            put_error = true
            alerts.push("Este nó não deve possuir filhos")
        }

        if (cachedSettings?.datasets && (props.dataset || "").length === 0) {
            put_error = true
            alerts.push("Este nó deve ter um conjunto de dados selecionado")
        }

        if (cachedSettings?.datasets && (props.dataset || "").length > 0) {
            const targetEvt = props.target_event_type
            const validateSelectedRegion =
                targetEvt?.region ??
                getRegionFromEnvironment(targetEvt?.environment ?? '')
            const validateSelectedEnum = targetEvt?.enum
            if (
                !isCachedDatasetCompatibleWithMappings(
                    props.dataset,
                    cachedSettings.datasets,
                    mappings,
                    validateSelectedRegion,
                    validateSelectedEnum,
                )
            ) {
                put_error = true
                alerts.push(
                    "O conjunto de dados selecionado não é compatível com o tipo de evento",
                )
            }
        }

        if (!isV1) {
            if (!props.target_company_key && !props.search_with_business_group_key) {
                put_error = true
                alerts.push("Este nó deve ter uma base histórica (cliente) selecionada")
            }
            if (!props.target_event_type) {
                put_error = true
                alerts.push("Este nó deve ter um tipo de evento selecionado")
            }
        }

        if (!props.accumulated_field_path || props.accumulated_field_path.length === 0) {
            put_error = true
            alerts.push("Clique neste nó, abra a configuração e escolha um Campo Acumulado")
        } else {
            if (mappings.length > 0) {
                const accumulatedMapping = mappings.find(
                    m => m.path === props.accumulated_field_path
                )
                if (!accumulatedMapping) {
                    put_error = true
                    alerts.push(
                        "O Campo Acumulado deve existir no tipo de evento selecionado"
                    )
                } else if (accumulatedMapping.type !== "number") {
                    put_error = true
                    alerts.push("O Campo Acumulado deve ser um campo numérico")
                }
            }
        }

        const fields = props.fields || []
        if (fields.length === 0) {
            put_error = true
            alerts.push("Este nó deve ter pelo menos uma referência configurada")
        } else {
            const seen = new Set()
            for (const field of fields) {
                const sig = `${field.target_field_path},${field.comparison},${field.value ?? ""},${field.type ?? ""}`
                if (seen.has(sig)) {
                    put_error = true
                    alerts.push("Este nó não deve ter referências duplicadas")
                    break
                }
                seen.add(sig)
            }
            if (mappings.length > 0) {
                const hasInvalid = fields.some(f => {
                    if (!f?.target_field_path || f.target_field_path.length === 0) return true
                    if (f.comparison == null || f.comparison === "") return true
                    const mapping = mappings.find(m => m.path === f.target_field_path)
                    if (!mapping) return true
                    if (
                        f.type === "static" &&
                        f.value !== undefined &&
                        f.value !== "" &&
                        !validateConstantValues(mapping.type, f.value)
                    ) {
                        return true
                    }
                    return false
                })
                if (hasInvalid) {
                    put_error = true
                    alerts.push(
                        "Todas as referências devem ter campo, comparação e valor válidos"
                    )
                }
            }
        }

        if (props.timedelta_value) {
            if (!validateConstantValues("timedelta", props.timedelta_value)) {
                put_error = true
                alerts.push("Deve ser fornecido um período de tempo válido")
            }
            if (cachedSettings?.timedelta_value) {
                const settingsDuration = moment.duration(cachedSettings.timedelta_value)
                const propertiesDuration = moment.duration(props.timedelta_value)
                if (propertiesDuration.asMilliseconds() > settingsDuration.asMilliseconds()) {
                    put_error = true
                    alerts.push("O período de tempo considerado por esse nó não pode exceder " + this.formatTimedelta(settingsDuration))
                }
            }
        }

        if (node.parentNode != null && node.parentNode.on_error) {
            put_error = true
            alerts.push("O nó superior está inválido")
        }
        return { validated: !put_error, alerts }
    }

    getType(node){
        return "number"
    }
}
